import React, { Component } from 'react';
import { Row, Col, Card, Space, Typography, Radio } from 'antd';
import Header from '../Header';
import ReactAudioPlayer from 'react-audio-player';
import { withTranslation } from 'react-i18next';
import CButton from '../../../../../../../components/Button';

const { Text } = Typography;

export class S1Q1_5 extends Component {
  constructor(props) {
    super(props)
    
    const arrRef = ['1', '2', '3', '4', '5']
    this.audioRef = arrRef.map(() => React.createRef())
  }

  handlePlay = (i) => {
    this.audioRef.map((item, iRef) => 
      i === iRef  ? item.current.audioEl.current.play() : item.current.audioEl.current.pause()
    )
  }

  render() {
    const { questionListening, handleSelect, handleNext, result, t } = this.props
    const arrQuestion = questionListening.filter((res,i) => i < 5)
    return (
      <React.Fragment>
        <Row className='mt-16'>
          <Col lg={{ span: 20, offset: 2 }} xxl={{ span: 18, offset: 3 }}>
            <Header {...this.props} />

            <Card className="card-body-question mt-16 mb-16 border-radius-8">
              <Row gutter={[64,32]}>
                <Col span={24}>
                  <Space className="text-align-center width-100" direction="vertical" size={0}>
                    {/* <Text className='dark-color fs-20' style={{ fontWeight: 'normal', fontStyle: 'italic' }} strong>{t('pathway.listening')}</Text> */}
                    <Text className='dark-color fs-20' style={{ fontWeight: 'normal', fontStyle: 'italic' }} strong>Listening</Text>
                    <Text className='dark-color fs-16' style={{ fontWeight: '600', fontStyle: 'italic' }} strong>Section 1</Text>
                  </Space>
                </Col>
                {
                  arrQuestion.map((item, i) =>
                    <Col key={i} lg={12} xs={24}>
                      <Space className='width-100' align="start">
                        <Text>{i+1}.</Text>
                        <Space className='width-100' direction="vertical">
                          <Space className='width-100' direction='vertical'>
                            <ReactAudioPlayer
                              ref={this.audioRef[i]}
                              src={item.audio}
                              autoPlay={false}
                              controls
                              controlsList="nodownload noplaybackrate"
                              onPlay={() => this.handlePlay(i)}
                            />
                            <Text className='noselect' style={{ fontSize: 15, fontWeight: 'normal', fontStyle: 'italic', color: '#FF0000'}}>{item.title1}</Text>
                            <Text className='noselect' style={{ fontSize: 15, fontWeight: 'normal', color: '#FF0000' }}>{item.title2}</Text>
                            <Text className='noselect dark-color fs-15' strong>Question:</Text>
                            <Text className='noselect dark-color' style={{ fontSize: 15, fontWeight: 'normal' }}>{item.question}</Text>
                          </Space>
                          <Radio.Group className='width-100' value={result?.find(item => item.no === i+1)?.selected} onChange={(e) => handleSelect(e,i+1)}>
                            <Space className='width-100' direction="vertical">
                              {
                                item.answers.map((res,iAnswer) =>
                                  <Radio className='noselect' key={iAnswer} result={res.value} value={iAnswer} style={{ whiteSpace: 'break-spaces', display: 'flex', alignItems: 'center' }}>{res.answerLabel}</Radio>
                                )
                              }
                            </Space>
                          </Radio.Group>
                        </Space>
                      </Space>
                    </Col>
                  )
                }
                <Col span={24} >
                  <Space className='float-right'>  
                    <CButton type="primary-icon" size="large" action={() => handleNext(1,2,result?.length>=5)} title={t('pathway.next')} icon='RightOutlined'/>
                  </Space>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

export default withTranslation()(S1Q1_5)
